import type { ComponentType, SVGProps } from 'react';
import type { BusinessModeType } from '../../types';
import SvgGrid from 'components/svg/SvgGrid';
import SvgSun from 'components/svg/SvgSun';
import SvgTool from 'components/svg/SvgTool';
import SvgOff from 'components/svg/SvgOff';
import SvgShuffle from 'components/svg/SvgShuffle';
import SvgImage from 'components/svg/SvgImage';
import SvgLock from 'components/svg/svgLock';
import SvgPackage from 'components/svg/SvgPackage';
import SvgSetting from 'components/svg/SvgSetting';

export type ModeCardConfig = {
    value: BusinessModeType;
    Icon: ComponentType<SVGProps<SVGSVGElement>>;
};

export const MODE_CARDS: ModeCardConfig[] = [
    { value: 'general', Icon: SvgGrid },
    { value: 'solar', Icon: SvgSun },
    { value: 'hvac', Icon: SvgTool },
    { value: 'electrical', Icon: SvgOff },
    { value: 'plumbing', Icon: SvgShuffle },
    { value: 'windows', Icon: SvgImage },
    { value: 'security', Icon: SvgLock },
    { value: 'construction', Icon: SvgPackage },
    { value: 'custom', Icon: SvgSetting },
];

export const FIELDS_TABLE_MIN_WIDTH = 640;
export const FIELDS_TABLE_COL_NAME = 280;
export const FIELDS_TABLE_COL_TYPE = 140;
export const FIELDS_TABLE_COL_VALUES = 220;

export const BUSINESS_MODE_PERSIST_FIELDS = ['mode', 'modeFields', 'customModeFields'] as const;
